import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { SaveAlt } from '@mui/icons-material';
import palette from '@theme/palette';
import { useTranslation } from 'react-i18next';
import { Button } from '@shared/ui/Button';
import { buildRepresentationChips, downloadAssetKey, useSolution, useValidationUiStore } from '@entities/solution';
import { ImageGallery } from './ImageGallery';
export function Representations() {
    const { t } = useTranslation();
    const { id: fileId } = useParams();
    const { selectedSolutionId } = useValidationUiStore();
    const { data: solution } = useSolution(fileId, selectedSolutionId);
    const items = useMemo(() => buildRepresentationChips(solution === null || solution === void 0 ? void 0 : solution.representations), [solution === null || solution === void 0 ? void 0 : solution.representations]);
    if (items.length === 0) {
        return (_jsx(Box, { display: "flex", justifyContent: "center", alignItems: "center", height: "400px", children: _jsx(Typography, { sx: { fontSize: '15px', color: palette.secondary.text }, children: t('Solution representation not found') }) }));
    }
    return (_jsx(Box, { bgcolor: palette.common.white, borderRadius: '8px', p: 3, children: _jsx(ImageGallery, { items: items, renderActions: item => item.jsonKey ? (_jsx(Button, { size: "medium", variant: "contained", startIcon: _jsx(SaveAlt, {}), onClick: () => downloadAssetKey(item.jsonKey, `${item.label.replace(/\s+/g, '_')}.json`), children: t('Download JSON') })) : null }) }));
}
